import type { FC } from 'react'

import { useLessonQuery } from '@segment/api/routes/growthMasters/queries'

import Layout from '../components/Layout'

import WantToLearnMore from '../components/WantToLearnMore'

import Hero from './Hero'
import RecommendedLessons from './RecommendedLessons'
import Resources from './Resources'

export interface LessonProps {
  slug: string
}
const Lesson: FC<LessonProps> = ({ slug }) => {
  const { data: lesson } = useLessonQuery({ args: [slug] })

  if (!lesson) throw new Error(`Lesson is missing. Make sure it's preloaded`)

  return (
    <Layout pageName="Lesson">
      <Hero
        slug={slug}
        title={lesson.title}
        description={lesson.shortDescription}
        badges={lesson.badges}
        speaker={lesson.speaker}
        videoUrl={lesson.videoUrl}
        videoThumbnail={lesson.videoCoverUrl}
      />
      {lesson.resources.length > 0 && <Resources resources={lesson.resources} />}
      <RecommendedLessons lessons={lesson.recommended} />
      <WantToLearnMore />
    </Layout>
  )
}

export default Lesson
